import React from "react";
import ChipEditor from "./ChipEditor";
import Pill from "./Pill";
import { DiagramButton } from "./Diagram";
import { Tag, Label } from "./ui";
import { FF, T, MINUTE_PRESETS } from "../lib/constants";
import { lessonBlocks, fmtDur } from "../lib/blocks";
import { lessonMinutes } from "../lib/library";

// Eén losse les als kaart (build 2.5): dezelfde opbouw als een weekles
// (warming-up, oefening 1, oefening 2, wedstrijdvorm). Gebruikt in de bibliotheek, zowel
// voor lessen uit het seizoensplan (alleen lezen) als voor eigen lessen (bewerken).
export default function LessonCard({ mob, item, lv, meta, canEdit, onField, onPart, extra, top }) {
  var parts = item.parts || {};
  var ink = lv.ink || lv.color;
  var px = mob ? 16 : 22;
  var inputBase = { border: "1px solid " + T.line, borderRadius: 8, outline: "none", fontFamily: FF, color: T.ink, background: "#fff", boxSizing: "border-box" };
  var minutes = lessonMinutes(parts);

  return (
    <article style={{ background: T.card, borderRadius: 18, border: "1px solid " + T.line2, overflow: "hidden", fontFamily: FF }}>
      <div style={{ background: lv.color, color: lv.on || "#fff", padding: mob ? "12px 16px" : "14px 22px", display: "flex", alignItems: "baseline", justifyContent: "space-between", gap: 12 }}>
        <span style={{ fontWeight: 800, fontSize: mob ? 19 : 21, minWidth: 0, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{lv.label}</span>
        <span style={{ fontSize: 13, whiteSpace: "nowrap" }}>{(meta ? meta + " · " : "") + fmtDur(minutes, "min")}</span>
      </div>

      <div style={{ padding: "14px " + px + "px", borderBottom: "1px solid " + T.line, display: "flex", flexDirection: "column", gap: 10 }}>
        {canEdit
          ? <input value={item.name || ""} aria-label="Naam van de les" onChange={function (e) { onField("name", e.target.value); }} placeholder="Naam van de les"
              style={Object.assign({}, inputBase, { padding: "8px 12px", fontSize: mob ? 19 : 22, fontWeight: 800, width: "100%" })} />
          : (<div>
              <h1 style={{ margin: 0, fontWeight: 800, fontSize: mob ? 21 : 25, lineHeight: 1.2, color: T.ink }}>{item.name || "Naamloze les"}</h1>
              {item.sub && <p style={{ margin: "2px 0 0", fontSize: 14, color: T.muted }}>{item.sub}</p>}
            </div>)}
        {extra}
        {top}
        {canEdit
          ? <div><Label>Type (tags)</Label><ChipEditor items={item.tags || []} onChange={function (v) { onField("tags", v); }} placeholder="Tag toevoegen (bv. forehand, volley)..." color={ink} /></div>
          : ((item.tags || []).length > 0 && <div style={{ display: "flex", gap: 4, flexWrap: "wrap" }}>{item.tags.map(function (t, i) { return <Tag key={i} text={t} lv={lv} />; })}</div>)}
      </div>

      {!canEdit && (item.theme || item.adjustments) && (
        <div style={{ display: mob ? "block" : "grid", gridTemplateColumns: "1fr 1fr", borderBottom: "1px solid " + T.line, background: lv.bg }}>
          {[["theme", "Thema & focus"], ["adjustments", "Groepsaanpassingen"]].map(function (pair, i) {
            return (
              <div key={pair[0]} style={{ padding: "12px " + px + "px", borderRight: !mob && i === 0 ? "1px solid " + lv.border : "none", borderBottom: mob && i === 0 ? "1px solid " + lv.border : "none" }}>
                <h2 style={{ margin: "0 0 4px", fontSize: 11, fontWeight: 700, letterSpacing: 0.6, textTransform: "uppercase", color: ink }}>{pair[1]}</h2>
                <p style={{ margin: 0, fontSize: 13, lineHeight: 1.6, color: "#4A4740", whiteSpace: "pre-line" }}>{item[pair[0]] || "—"}</p>
              </div>
            );
          })}
        </div>
      )}

      {lessonBlocks(parts, lv).map(function (ex) {
        var exd = ex.data;
        return (
          <div key={ex.key} style={{ display: "grid", gridTemplateColumns: mob ? "56px minmax(0, 1fr)" : "72px minmax(0, 1fr) auto", borderBottom: "1px solid " + T.line, minHeight: 76, background: ex.tint || "transparent" }}>
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 6, padding: "14px 4px" }}>
              <div style={{ width: 32, height: 32, borderRadius: 16, background: ex.bg, display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 700, fontSize: 14, color: ex.fg }}>{ex.icon}</div>
              {canEdit
                ? <select value={String(exd.time || 0)} aria-label={"Minuten " + ex.label} onChange={function (e) { onPart(ex.key, "time", parseFloat(e.target.value) || 0); }}
                    style={{ width: 52, height: 32, border: "1px solid " + T.line, borderRadius: 8, fontSize: 12, fontWeight: 700, background: T.soft, color: T.ink, fontFamily: FF, textAlign: "center" }}>
                    {minuteOptions(exd.time).map(function (m) { return <option key={m} value={m}>{fmtDur(m)}</option>; })}
                  </select>
                : <span style={{ fontSize: 12, fontWeight: 700, color: T.muted }}>{fmtDur(exd.time, "min")}</span>}
            </div>
            <div style={{ padding: mob ? "12px 14px 12px 4px" : "12px 18px 12px 4px", minWidth: 0 }}>
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 8, marginBottom: 6 }}>
                <div style={{ fontSize: 11, fontWeight: 700, color: T.muted, textTransform: "uppercase", letterSpacing: 0.6 }}>{ex.label}</div>
                <DiagramButton diagram={exd.diagram} canEdit={canEdit} title={(item.name ? item.name + " · " : "") + ex.label}
                  onSave={function (v) { onPart(ex.key, "diagram", v); }} />
              </div>
              {canEdit
                ? (<div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                    <textarea value={exd.description || ""} aria-label={"Uitleg " + ex.label} onChange={function (e) { onPart(ex.key, "description", e.target.value); }} placeholder="Uitleg..." rows={2}
                      style={Object.assign({}, inputBase, { width: "100%", padding: 8, fontSize: 14, lineHeight: 1.5, resize: "vertical", color: "#4A4740" })} />
                    <ChipEditor items={exd.accents || []} onChange={function (v) { onPart(ex.key, "accents", v); }} placeholder="Accent toevoegen..." color={ex.ink} />
                  </div>)
                : (<div>
                    <p style={{ margin: 0, fontSize: 14, lineHeight: 1.55, color: exd.description ? "#4A4740" : "#B5B0A6", whiteSpace: "pre-line" }}>{exd.description || "—"}</p>
                    {mob && exd.accents && exd.accents.length > 0 && <div style={{ display: "flex", flexWrap: "wrap", gap: 4, marginTop: 8 }}>{exd.accents.map(function (a, i) { return <Pill key={i} text={a} clr={ex.ink} />; })}</div>}
                  </div>)}
            </div>
            {!canEdit && !mob && exd.accents && exd.accents.length > 0 && (<div style={{ padding: "14px 18px", display: "flex", flexDirection: "column", gap: 4, alignItems: "flex-end", minWidth: 130, maxWidth: 340 }}>{exd.accents.map(function (a, i) { return <Pill key={i} text={a} clr={ex.ink} />; })}</div>)}
          </div>
        );
      })}
    </article>
  );
}

function minuteOptions(cur) {
  var list = [0, 2.5, 7.5, 12.5, 17.5].concat(MINUTE_PRESETS, [25, 30, 40, 45]);
  var c = Number(cur) || 0;
  if (list.indexOf(c) < 0) list.push(c);
  return list.sort(function (a, b) { return a - b; });
}
